import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoryWithImages } from '../_models/gallery';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';


@Injectable({
  providedIn: 'root'
})
export class GalleryService {

  constructor(private http: HttpClient) { }

  public static readonly EVENTS_CONTROLLER_URL=environment.apiURL+"api/gallery/events"

  getEvents(): Observable<CategoryWithImages[]> {
      return this.http.get<CategoryWithImages[]>(GalleryService.EVENTS_CONTROLLER_URL);
  }
}
